<template>
  <div class="td-email flex items-center space-x-2 justify-start">
    <vk-icon icon="mail" /> <span>{{ model }}</span>
  </div>
</template>

<script>
export default {
  name: "email",
  data() {
    return {
      model: null
    };
  },
  props: ["input", "form", "rowdata"],
  created() {
    this.model = this.rowdata;
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("change", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style>
.td-email {
  white-space: pre;
}
</style>
